/* eslint-disable array-bracket-newline */
import { Network, enums } from '@kattana-io/common';
import { toChecksumAddressWrapper } from './checksumAddress';

import KTNIcon from '../molecules/PairIcons/icons/KTN.svg';

/**
 * List of KTN tokens (lowercased)
 */
export const KTN_Tokens = [
  '0x491e136ff7ff03e6ab097e54734697bb5802fc1c',
  '0xdae6c2a48bfaa66b43815c5548b10800919c993e',
];

/**
 * List of DEXE tokens (lowercased)
 */
export const DEXE_Tokens = [
  '0xde4ee8057785a7e8e800db58f9784845a5c2cbd6',
  '0x039cb485212f996a9dbb85a9a75d898f94d38da6',
];

/**
 * List of CDP tokens (lowercased)
 */
export const CDP_Tokens = ['0x6f0dda6b522fcc7807ccaca4d37ef6958e95e1b9'];

/**
 * List of OKT tokens (lowercased)
 */
export const OKT_Tokens = ['0x8f8526dbfd6e38e3d8307702ca8469bae6c56c15'];

/**
 * List of TON tokens (lowercased)
 */
export const TON_Tokens = ['eqcm3b12qk1e4yzsf8gtbrt0almnyesbc_dhvfrrtoefflez'];

/**
 * List of TRX tokens (lowercased)
 */
export const TRX_Tokens = ['tnuc9qb1rrps5cbwlmnmxxbjyfoydxjwfr'];

interface IIconProvideArguments {
  ticker?: any;
  network: Network;
  exchange?: string;
  contract?: string;
  kind: enums.ETickerKind;
}
/**
 * Implements a class which does routing for icons
 */
class IconProvider {
  kind: enums.ETickerKind | undefined;
  network: Network | undefined;
  contract: string | undefined;
  name: string | undefined;
  ticker: any;
  exchange: string | undefined;

  constructor({
    ticker,
    network,
    exchange,
    contract,
    kind,
  }: IIconProvideArguments) {
    this.ticker = ticker;
    this.network = network;
    this.contract = contract;
    this.kind = kind;
    this.exchange = exchange;
  }

  static createFromNetworkAndPair(network: Network, pair: string | undefined) {
    return new IconProvider({
      network,
      contract: pair,
      kind: 2,
    });
  }

  static createFromExchangeAndContract(
    exchange: string,
    contract: string,
    chain: string
  ) {
    const network = Network.fromChain(chain);

    if (network) {
      return new IconProvider({
        network,
        exchange,
        contract,
        kind: 2,
      });
    }
    return null;
  }

  url = (): string => {
    // if (this.exchange) {
    // }
    if (this.network && this.contract) {
      if (this.network.isELROND()) {
        return `https://raw.githubusercontent.com/ElrondNetwork/assets/master/tokens/${this.contract}/logo.svg`;
      }
      if (this.network.isMETER()) {
        return `https://raw.githubusercontent.com/kattana-io/additional-icons/main/blockchains/meter/${this.contract}.svg`;
      }
      if (this.network.isHECO()) {
        return `https://raw.githubusercontent.com/kattana-io/additional-icons/main/blockchains/heco/${toChecksumAddressWrapper(
          this.contract
        )}.png`;
      }
      if (this.network.isAVAX()) {
        return `https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/${toChecksumAddressWrapper(
          this.contract
        )}/logo.png`;
      }
      if (this.network.isOKX()) {
        if (OKT_Tokens.includes(this.contract.toLowerCase())) {
          return 'https://kattana-icons.s3.amazonaws.com/okt.png';
        }
        return `https://raw.githubusercontent.com/kattana-io/additional-icons/main/blockchains/okc/${this.contract.toLocaleLowerCase()}.png`;
      }
      if (this.network.isBASE()) {
        return `https://tokens.pancakeswap.finance/images/base/${this.contract}.png`;
      }
      if (this.network.isPULSECHAIN()) {
        if (CDP_Tokens.includes(this.contract.toLowerCase())) {
          return 'https://kattana-icons.s3.amazonaws.com/0x6f0dDa6b522fcC7807CcacA4D37eF6958e95E1B9.png';
        }
        return `https://tokens.app.pulsex.com/images/tokens/${this.contract}.png`;
      }
      if (this.network.isHARMONY()) {
        return `https://raw.githubusercontent.com/kattana-io/additional-icons/main/blockchains/harmony/${this.contract}.png`;
      }
      if (this.network.isZKSYNC()) {
        return `https://raw.githubusercontent.com/kattana-io/additional-icons/main/blockchains/zksync/${this.contract}.png`;
      }
      if (this.network.isTON()) {
        if (TON_Tokens.includes(this.contract.toLowerCase())) {
          return 'https://raw.githubusercontent.com/kattana-io/additional-icons/main/blockchains/ton/TON.svg';
        }
        return `https://assets.trustwalletapp.com/blockchains/ton/assets/${this.contract}/logo.png`;
      }
      if (this.network.isTron()) {
        if (TRX_Tokens.includes(this.contract.toLowerCase())) {
          return 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/tron/info/logo.png';
        }
        return `https://assets.trustwalletapp.com/blockchains/tron/assets/${this.contract}/logo.png`;
      }
      if (DEXE_Tokens.includes(this.contract.toLowerCase())) {
        return 'https://kattana-icons.s3.amazonaws.com/DEXE.svg';
      }
      if (KTN_Tokens.includes(this.contract.toLowerCase())) {
        return KTNIcon;
      }
      return `https://assets.trustwalletapp.com/blockchains/${this.network.toTrustWallet()}/assets/${toChecksumAddressWrapper(
        this.contract
      )}/logo.png`;
    }
    return '';
  };
}

export default IconProvider;
